export default __webpack_public_path__ + "static/media/richard.17058f4e.jpg";